import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/dialog'

import { LeadForm } from './LeadForm'

export function AddLeadDialog({
  open,
  onOpenChange,
  lead,
  module = 'marketing',
  onSuccess,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="
          w-[calc(100%-24px)]
          sm:max-w-2xl
          md:max-w-3xl
          max-h-[calc(100dvh-32px)]
          overflow-y-auto
          rounded-3xl
          p-4
          sm:max-h-[90vh]
          sm:p-6
        "
      >
        <DialogHeader>
          <DialogTitle className="text-xl sm:text-2xl">
            {lead ? 'Edit Lead' : 'Add Lead'}
          </DialogTitle>
        </DialogHeader>

        <LeadForm
          key={lead?.id ?? lead?._id ?? 'new'}
          lead={lead}
          module={module}
          onCancel={() => onOpenChange(false)}
          onSuccess={() => {
            onSuccess?.()
            onOpenChange(false)
          }}
        />
      </DialogContent>
    </Dialog>
  )
}
